/**
 * @fileoverview Scroll to Top Button Implementation
 * @description Implements a scroll-to-top button that appears when scrolling down and smoothly scrolls to top when clicked
 *
 * HTML Structure Required:
 * - Element with class "scroll-top" for the scroll-to-top button
 */

(function () {
  /**
   * @function scrollTop
   * @description Initializes the scroll-to-top functionality
   * - Shows/hides button based on scroll position
   * - Handles smooth scrolling to top on click
   */
  const scrollTop = () => {
    const btnScrollTop = document.querySelector('.scroll-top');
    window.addEventListener('scroll', function () {
      if (btnScrollTop) {
        if (scrollY > document.documentElement.clientHeight) {
          btnScrollTop.classList.add('show');
        } else {
          btnScrollTop.classList.remove('show');
        }
      }
    });

    btnScrollTop.onclick = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
  };

  // Initialize on page load
  scrollTop();

  // Reinitialize on Shopify section load
  document.addEventListener('shopify:section:load', function () {
    scrollTop();
  });
})();
